import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Profile from '../views/Profile.vue';
import Request from '../views/Request.vue';
import Guide from '../views/Guide.vue';
// import FAQ from '../views/FAQ.vue';
import ForgotPass from '../views/ForgotPass.vue';
import Payment from '../views/Payment.vue';
import PaymentReciept from '../views/PaymentReciept.vue';
import ApplyForMeter  from '../views/ApplyForMeter.vue';
import VueApexCharts from 'vue-apexcharts';
import { getCookie } from "../utils";
const FAQ = require(`@/views/Projects/${process.env.VUE_APP_CLIENTNAME}/FAQ.vue`).default;


Vue.use(VueApexCharts);
Vue.use(Router);
Vue.component('apexchart', VueApexCharts);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: {
      guest: true,
    },
  }
    ,
    {
      path: '/paymentReceipt',
      name: 'PaymentReceipt',
      component: PaymentReciept,
      meta: {
        requiresAuth: true
      },
    }
      ,
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true,
      },
    },
    {
      path: '/forgot-pass',
      name: 'ForgotPass',
      component: ForgotPass,
      meta: {
        guest: true,
      },
    },
    {
      path: '/apply-for-meter',
      name: 'ApplyForMeter',
      component: ApplyForMeter,
      meta: {
        guest: true,
      },
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/guide',
      name: 'Guide',
      component: Guide,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/request',
      name: 'Request',
      component: Request,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if ( getCookie('user_id') == null ) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if ( getCookie('user_id')==null ) {
      next();
    } else {
      next({ name: 'Home' });
    }
  } else {
    next();
  }
});

export default router;
